import React from "react";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Button from "components/CustomButtons/Button.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import headerLinksStyle from "assets/jss/material-dashboard-react/components/headerLinksStyle.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import TextField from "@material-ui/core/TextField";
import CardBody from "components/Card/CardBody.jsx";
import ModalPregunta from "components/Generales/ModalPregunta";
import ModalAulas from "./ModalAulas.jsx";
// material-ui icons
import Snackbar from "components/Snackbar/Snackbar.jsx";
import ModalCargando from "../../../../components/Generales/ModalCargando";
import Globales from "utils/Globales";
import { Edit, Search, Close } from "@material-ui/icons";
import InputAdornment from "@material-ui/core/InputAdornment";

class CatAulas extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      _id: "",
      FiltrarNombres: "",
      ListadeAulas: [],
      ListadeAulasTem: [],
      aulaSeleccionado: {},
      Disabled: false,
      mensaje: "",
      br: false,
      show: false,
      cargando: false,
      colorNotificacion: "success",
      colorTableRow: "white",
      errorIDaula: false,
      entroEliminar: false,
      notificacion: false,
      Total: 0,
      Capacidad: 0,
      TotalSeleccionado: 0,
      Titulo: "Registrar una nueva aula",
    };
    //Variable global para indicar el total de registros que se obtendra de la base de datos
    global.entrar = true;
    //this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.ListaGeneralaulas();
  }

  async ListaGeneralaulas() {
    this.setState({ cargando: this.state.entroEliminar ? false : true });
    await fetch(Globales.Url + "Catalogos/aulas/ListaGeneralaulas", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: Globales.token,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.error) {
          //Error en la respuesta
          this.setState({
            mensaje: data.mensaje,
            colorNotificacion: "danger",
            Activo: 1,
            cargando: false,
            entroEliminar: false,
          });
          this.showNotification();
        } else {
          if (data.ListadeAulas.Aula.length > 1) {
            this.setState({
              ListadeAulas: data.ListadeAulas.Aula,
              ListadeAulasTemp: data.ListadeAulas.Aula,
              Activo: 1,
              cargando: false,
              entroEliminar: false,
              FiltrarNombres: "",
            });
          } else {
            this.setState({
              ListadeAulas: data.ListadeAulas.Aula,
              ListadeAulasTemp: [...data.ListadeAulas.Aula],
              Activo: data.ListadeAulas.Aula.length,
              cargando: false,
              entroEliminar: false,
              FiltrarNombres: "",
            });
          }
        }
      })
      .catch((err) => console.error("El error es", err));
  }

  //Función para obtener el texto de los inputs
  handleChange(e) {
    const { name, value } = e.target;
    if (name === "FiltrarNombres") {
      const Dataorg = this.state.ListadeAulasTemp;
      if (value) {
        const NuevaData = Dataorg.filter((aula) =>
          String(aula.Nombre)
            .toUpperCase()
            .includes(String(value).toUpperCase())
        );

        if(NuevaData.length === 0){
          this.setState({
            FiltrarNombres: value,
            ListadeAulas: NuevaData,
            colorNotificacion: "danger",
            mensaje: "No se encontraron coincidencias",
          });
          this.showNotification();
        }
        else{
          this.setState({
            FiltrarNombres: value,
            ListadeAulas: NuevaData,
          });
        }
      } else {
        this.setState({
          FiltrarNombres: "",
          ListadeAulas: [...Dataorg],
        });
      }
    }
  }

  eventoModalEliminar(e) {
    this.setState({ show: true, aulaSeleccionado: e });
    return;
  }

  eventoModalPregunta = (valor) => {
    if (valor) {
      this.eliminaraula(this.state.aulaSeleccionado);
    } else {
      this.setState({ show: false });
    }
  };

  eliminaraula(id) {
    fetch(Globales.Url + "Catalogos/aulas/Eliminaraula", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: Globales.token,
      },
      body: JSON.stringify({ _id: id }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.error === undefined) {
          //Error al obtener los registros
          this.setState({ colorNotificacion: "danger" });
        } else if (data.error) {
          //Error al obtener los registros
          this.setState({ colorNotificacion: "danger" });
        } else {
          //Obtuvo los registros correctamente
          this.setState({ colorNotificacion: "success" });
        }
        this.setState({
          mensaje: data.mensaje
            ? data.mensaje
            : "El aula no puede ser eliminado, porque cuenta con niveles asignados.",
          show: false,
        });
        this.showNotification();
        this.ListaGeneralaulas();
      });
  }

  showNotification() {
    var x = [];
    this.setState({ br: true });
    this.setState(x);
    this.alertTimeout = setTimeout(
      function() {
        this.setState({ br: false });
        this.setState(x);
      }.bind(this),
      4000
    );
  }

  eventoModalaula = (mensaje, Color) => {
    this.setState({showAgregar: false})
    if(mensaje !== "esc"){
      this.setState({
        Titulo: "Nueva aula",
        mensaje: mensaje,
        Nombre: "",
        colorNotificacion: Color,
        op: 0,
        entroEliminar: true,
      });
      this.showNotification();
      this.ListaGeneralaulas();
    }
    //Cambiar valores por default
  };

  openModalNuevoaula = () => {
    //Cambiar valores por default
    this.setState({
      showAgregar: true,
      Titulo: "Nueva aula",
      Nombre: "",
      op: 0,
    });
  };

  openModalEditaraula = (e) => {
    //Cambiar valores por default
    this.setState({
      Nombre: e.Nombre,
      _id: e._id,
      Descripcion: e.Descripcion,
      Capacidad: e.Capacidad,
      Titulo: "Editar aula",
      op: 1,
      showAgregar: true,
    });
  };

  render() {
    const { classes } = this.props;
    let agregar;
    if (this.state.cargando == true) {
      agregar = (
        <ModalCargando Cuerpo={"Cargando"} show={this.state.cargando} />
      );
    }
     if (this.state.showAgregar == true) {
      agregar = (
        <ModalAulas
          xs={18}
          Titulo={this.state.Titulo}
          Nombre={this.state.Nombre}
          Descripcion={this.state.Descripcion}
          Capacidad={this.state.Capacidad}
          Aulas={this.state.ListadeAulasTemp}
          _id={this.state._id}
          showAgregar={this.state.showAgregar}
          eventClick={this.eventoModalaula}
          op={this.state.op}
        />
      );
    }

    return (
      <div>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={10}>
            <Card>
              <CardHeader color="info" text={true}>
                <h4 className={classes.cardTitle}>Filtro</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <TextField
                      id="FiltrarNombres"
                      style={{ width: "23vw" }}
                      variant="outlined"
                      type="text"
                      size="small"
                      label="Nombre del aula"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search />
                          </InputAdornment>
                        ),
                        onChange: this.handleChange.bind(this),
                        value: this.state.FiltrarNombres,
                        name: "FiltrarNombres",
                        id: "FiltrarNombres",
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <Button
                      size="sm"
                      type="submit"
                      color="info"
                      round
                      className="pull-right"
                      onClick={() => this.openModalNuevoaula()}
                    >
                      Nuevo
                    </Button>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
            <Card>
              <CardHeader color="info">
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <h4 className="pull-left">Lista de aulas</h4>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <h4
                      className="pull-right"
                      style={{ marginRight: "15px", marginTop: 0 }}
                    >
                      {this.state.ListadeAulas.length} aula(s)
                    </h4>
                  </GridItem>
                </GridContainer>
              </CardHeader>
              <CardBody>
                <div className="table-responsive text-nowrap table-wrapper-scroll-y">
                  <table className="table table-sm table-hover">
                    <thead>
                      <tr>
                        <th className="center">Nombre</th>
                        <th className="center">Descripción</th>
                        <th className="center">Capacidad</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.ListadeAulas.map((aula, index) => {
                        return (
                          <tr key={aula._id + "-" + index}>
                            <td onClick={() => this.openModalEditaraula({ Nombre: aula.Nombre, Capacidad: aula.Capacidad, _id: aula._id, Descripcion: aula.Descripcion,})} style={{verticalAlign: "middle", cursor: "default"}}>{aula.Nombre}</td>
                            <td onClick={() => this.openModalEditaraula({ Nombre: aula.Nombre, Capacidad: aula.Capacidad, _id: aula._id, Descripcion: aula.Descripcion,})} style={{verticalAlign: "middle", cursor: "default"}}>{aula.Descripcion}</td>
                            <td onClick={() => this.openModalEditaraula({ Nombre: aula.Nombre, Capacidad: aula.Capacidad, _id: aula._id, Descripcion: aula.Descripcion,})} style={{verticalAlign: "middle", cursor: "default"}}>{aula.Capacidad}</td>
                            <td style={{verticalAlign: "middle", cursor: "default"}}>
                            <Button
                                color="danger"
                                round
                                justIcon
                                className="pull-right"
                                size="sm"
                                onClick={() =>
                                  this.eventoModalEliminar(aula._id)
                                }
                              >
                                <Close />
                              </Button>
                              <Button
                                color="info"
                                round
                                justIcon
                                className="pull-right mr-2"
                                size="sm"
                                onClick={() =>
                                  this.openModalEditaraula({
                                    Nombre: aula.Nombre,
                                    Capacidad: aula.Capacidad,
                                    _id: aula._id,
                                    Descripcion: aula.Descripcion,
                                  })
                                }
                              >
                                <Edit />
                              </Button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <div id="">
          <ModalPregunta
            Titulo={"Eliminar aula"}
            Cuerpo={"¿Está seguro de dar de baja el aula?"}
            show={this.state.show}
            eventClick={this.eventoModalPregunta}
          />
          {agregar}
        </div>
        <div id="">
          <Snackbar
            place="tr"
            color={this.state.colorNotificacion}
            message={this.state.mensaje}
            open={this.state.br}
            closeNotification={() => this.setState({ br: false })}
            close
          />
        </div>
      </div>
    );
  }
}

export default withStyles(headerLinksStyle)(CatAulas);
